import { ReactNode } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useAppContext } from "@/src/config/AppProvider";
import AnnouncementCards from "./subs/AnnouncementCards";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";

const ClassicBanner = (): ReactNode => {
  const { getLocalization } = useAppContext();
  const routes = useBrowserRoutes();
  const { t } = useTranslation();

  return (
    <div className="rbt-banner-area rbt-banner-1 variation-2 height-750">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-8">
            <div className="content">
              <div className="inner">
                <div className="rbt-new-badge rbt-new-badge-one">{getLocalization("homeEmphasis")}</div>
                <h1 className="title">{getLocalization("homeSlogan")}</h1>
                <p className="description">{getLocalization("homeSloganDescription")}</p>
                <div className="slider-btn">
                  <Link className="rbt-btn btn-gradient hover-icon-reverse" href={routes.contact}>
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">{t("contactUs")}</span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="content">
              <div className="banner-card pb--60 swiper rbt-dot-bottom-center banner-swiper-active">
                <AnnouncementCards />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassicBanner;
